import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

const Redeem = () => {
  const [code, setCode] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleRedeem = async () => {
    try {
      setIsLoading(true);

      // First, check if the code exists and is unused
      const { data: codeData, error: codeError } = await supabase
        .from("appsumo_codes")
        .select("*")
        .eq("code", code)
        .eq("status", "unused")
        .single();

      if (codeError || !codeData) {
        toast.error("Invalid or already used code");
        return;
      }

      // If code is valid, redirect to signup with the code as a query parameter
      navigate(`/auth?appsumo_code=${code}`);
    } catch (error: any) {
      toast.error(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="w-full max-w-md space-y-8 p-8">
        <div className="text-center">
          <h2 className="text-2xl font-bold">Redeem AppSumo Code</h2>
          <p className="text-muted-foreground mt-2">
            Enter your AppSumo code to activate your pro account
          </p>
        </div>

        <div className="space-y-6">
          <div className="space-y-2">
            <Label htmlFor="code">AppSumo Code</Label>
            <Input
              id="code"
              value={code}
              onChange={(e) => setCode(e.target.value)}
              placeholder="Enter your code"
              required
            />
          </div>

          <Button
            onClick={handleRedeem}
            className="w-full"
            disabled={isLoading || !code}
          >
            {isLoading ? "Verifying..." : "Redeem Code"}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Redeem;